export default {
  state: {
    registerFields: {
      inputs: [
        {
          id: 'name',
          display: 'Nome e sobrenome',
          type: 'text',
          mask: '',
          required: true
        },
        {
          id: 'email',
          display: 'E-mail',
          type: 'email',
          mask: '',
          required: true
        },
        {
          id: 'senha',
          display: 'Senha (mín. 6 caracteres)',
          type: 'password',
          mask: '',
          required: true
        },
        {
          id: 'csenha',
          display: 'Confirme sua senha',
          type: 'password',
          mask: '',
          required: true
        },
        {
          id: 'phone',
          display: 'Celular com DDD',
          type: 'text',
          mask: '(00) 00000-0000',
          required: true
        },
        {
          id: 'cpf',
          display: 'CPF:',
          type: 'text',
          mask: '000.000.000-00',
          required: true
        },
        {
          id: 'cep',
          display: 'CEP',
          type: 'text',
          mask: '00000-000',
          required: true
        },
        {
          id: 'estado',
          display: 'Estado',
          type: 'text',
          mask: '',
          disabled: true,
          required: true
        },
        {
          id: 'cidade',
          display: 'Cidade',
          type: 'text',
          mask: '',
          disabled: true,
          required: true
        },
        {
          id: 'bairro',
          display: 'Bairro',
          type: 'text',
          mask: '',
          disabled: true,
          required: true
        },
        {
          id: 'logradouro',
          display: 'Logradouro',
          type: 'text',
          mask: '',
          disabled: true,
          required: true
        },
        {
          id: 'numero',
          display: 'Número',
          type: 'text',
          mask: '',
          required: true
        },
        {
          id: 'complemento',
          display: 'Complemento',
          type: 'text',
          mask: '',
          required: false
        }
      ]
    }
  },
  mutations: {},
  actions: {},
  getters: {
    inputs: (state) => state.registerFields.inputs
  }
}
